var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusBtnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30 15.3315 29.8683 15.6495 29.6339 15.8839C29.3995 16.1183 29.0815 16.25 28.75 16.25H16.25V28.75C16.25 29.0815 16.1183 29.3995 15.8839 29.6339C15.6495 29.8683 15.3315 30 15 30C14.6685 30 14.3505 29.8683 14.1161 29.6339C13.8817 29.3995 13.75 29.0815 13.75 28.75V16.25H1.25C0.918479 16.25 0.600537 16.1183 0.366117 15.8839C0.131696 15.6495 0 15.3315 0 15C0 14.6685 0.131696 14.3505 0.366117 14.1161C0.600537 13.8817 0.918479 13.75 1.25 13.75H13.75V1.25C13.75 0.918479 13.8817 0.600537 14.1161 0.366117C14.3505 0.131696 14.6685 0 15 0C15.3315 0 15.6495 0.131696 15.8839 0.366117C16.1183 0.600537 16.25 0.918479 16.25 1.25V13.75H28.75C29.0815 13.75 29.3995 13.8817 29.6339 14.1161C29.8683 14.3505 30 14.6685 30 15Z",
    fill: "#B9B9B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBtnIcon);
export default __webpack_public_path__ + "static/media/plusBtnIcon.5dacc33eb9cd4197808d82462de6acce.svg";
export { ForwardRef as ReactComponent };